import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class RenameKeywordCommand extends AbstractCommand<Keyword> {

    public name = CommandName.RENAME_KEYWORD;

    public tags: string[] = [`entity`, `update`, `keyword`];

    constructor(payload: Keyword) {
        super('keyword', payload.uid, payload);
    }
}